import { AxiosRestApplicationClient as TillAxiosRestApplicationClient } from '@g2-shared/api-client/generated/till-app';
import {
  generateBaseAxiosClient,
  INotificationService,
  NotificationsService,
} from '@g2-shared/common';

const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const TillApiClient = new TillAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);

interface DIContextInterface {
  NotificationService: () => INotificationService;
  TillApiClient: TillAxiosRestApplicationClient;
}

export const DIContext = (): DIContextInterface => ({
  TillApiClient,
  NotificationService: NotificationsService,
});
